export default __webpack_public_path__ + "static/media/budgetTracker.8faf3993.gif";